import "./App.css";
 import { MuiPickersUtilsProvider } from "@material-ui/pickers";
/* import DateFnsUtils from "@date-io/date-fns"  */
import Routes from "./Router/routes";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./Authentication/AuthProvider";
import { connect } from "react-redux";

function App() {
  return (
    <>
    {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>  */}
        <AuthProvider>
          <BrowserRouter>
           <Routes />
          </BrowserRouter>
        </AuthProvider> 
    {/* </MuiPickersUtilsProvider> */}
    </> 
  );
}
function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, null)(App);
